import{defineStore}from"pinia";
import kontaktService from"@/services/Kontakt/kontakt.service";





export const useKontaktStore=defineStore("kontaktStore",{
state:()=>({
    loading:false,
    error:null,
    kontaktet:[]
}),

actions:{
    async getKontaktet(){
        this.loading=true;
        this.error=null;
        try{
            const response=await kontaktService.getKontaktet();
            this.kontaktet=response;
            return response;
        }catch(err){
            this.error=err.response?.data?.message||err.message||"Gabim gjatë marrjes së të dhënave";
        }finally{
            this.loading=false;
        }
    },
    async getKontaktetById(id){
        this.loading=true;
        this.error=null;
        try{
            const response=await kontaktService.getKontaktetById(id);
            return response;
        }catch(err){
            this.error=err.response?.data?.message||err.message||"Gabim gjatë marrjes së të dhënave";
        }finally{
            this.loading=false;
        }
    }
},



  getters: {
    contactCards: (state) =>
      state.kontaktet.map((item) => ({
        title: item.fullName,
        items: [
          {
            label: "Pozita",
            icon: "fa-solid fa-chevron-right",
            value: item.position || "—"
          },
          {
            label: "Email",
            icon: "fa-solid fa-envelope",
            value: item.email || "—"
          },
          {
            label: "Tel/Fix",
            icon: "fa-solid fa-phone-volume",
            value: item.telephone || "—"
          },
          {
            label: "Email Zyrtar",
            icon: "fa-solid fa-envelope",
            value: item.officialEmail || "—"
          },
          {
            label: "Adresa",
            icon: "fa-solid fa-location-dot",
            value: item.prokuroriaName || "—"
          }
        ]
      }))
  }

});